import React, {useEffect, useState} from "react";
import "../assets/css/App.css";
import "../assets/css/CustomHeader.css"
import {Fade} from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import CustomNavbar from "./CustomNavbar";
import {Images} from "../constants/Images";
import axios from "axios";
import opsToast from "../ops-library/ops-toast";

function CustomHeader({showSlides = true}) {

    const [coverImages, setCoverImages] = useState([])
    const [socialUrls, setSocialUrls] = useState({fbUrl: "", ytUrl: "", igUrl: ""})

    useEffect(() => {
        getCoverImages()
        getSocialUrls()
    }, []);

    function getCoverImages() {
        const configurationCover = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/upload?coverImg=true`,
        };

        axios(configurationCover)
            .then((result) => {
                setCoverImages(result.data.content);
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });

    }

    function getSocialUrls() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/webData/social-contacts`,
        };
        axios(configuration)
            .then((result) => {
                setSocialUrls(result.data.content)
            })
            .catch((error) => {
                console.log(error)
            });
    }

    function SlideImages() {
        return (
            <Fade cssClass={"header-fade-container"} duration={5000} pauseOnHover={false} arrows={false}
                  autoplay={true}>
                {coverImages !== undefined ? coverImages
                        ?.sort((a, b) => a.order - b.order)
                        .map((img, index) => (
                            <div className="each-slide-fade" key={index} id="home">
                                <img
                                    src={`${process.env.REACT_APP_API_BASE_URL}/${img.path}`} className="slide-img-cover"
                                    alt="cover_image"/>
                            </div>
                        ))
                    :
                    <div className="each-slide-fade">
                        <img src={Images.BETARKY} className="slide-img-cover"
                             alt="cover_image"/>
                    </div>
                }
            </Fade>
        )
    }

    return (
        <div className="header-container fa-flex-col w-100">
            <CustomNavbar socialUrls={socialUrls}/>
            {showSlides && <SlideImages/>}
        </div>
    );
};

export default CustomHeader;